module.exports = __webpack_public_path__ + "5985932a9512d8bae6630e2e3c46c259.svg";